import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/deals/[id]/estimations/edit/Page";

export const PATH = (id: number): string => `/deals/${id}/estimations/edit`;

const Estimations: NextPage = () => (
	<>
		<NskHead title="見積り作成" />
		<Component />
	</>
);

export default Estimations;
